<script>

import { Overlay } from '../../'

export default {
    name: 'TSMA',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'Mano', version: '1.0.0',
                desc: 'Trend Color SMA (TSMA) — VT / VT Laser trend baseline',
                preset: {
                    name: 'Trend Color SMA (TSMA) $length',
                    side: 'onchart',
                    settings: {
                        lineWidth: 3,
                        upColor: '#4aa93b',
                        downColor: '#b64545'
                    }
                }
            }
        },
        use_for() { return ['TSMA'] },
        calc() {
            return {
                props: {
                    length: { def: 50, text: 'Length' },
                    upColor: { def: '#4aa93b', text: 'Rising trend color', type: 'color' },
                    downColor: { def: '#b64545', text: 'Falling / flat trend color', type: 'color' }
                },
                conf: { renderer: 'SplineX' },
                update: `
                    return sma(close, length)[0]
                `
            }
        }
    }
}
</script>
